import React, { useState } from 'react';
import NavHistoryTracker from '../../../navigation/NavHistoryTracker';
import {
  HbrTab,
  HbrTabGroup,
  HbrTabPanel,
} from '@harbor/elements-react-standalone';
import { useNavigate, useParams } from 'react-router-dom';
import { ADMIN_URL_ENABLEMENT } from './admin-values';
import JourneyMapAdminPage from '../JourneyMap/JourneyMapAdminPage';
import EducationScopeAdminPage from '../EducationScope/EducationScopeAdminPage';
import JourneyMapAssignmentsAdminPage from '../JourneyMap/JourneyMapAssignmentsAdminPage';
import EnablementDueDatesAdminPage from '../JourneyMap/EnablementDueDatesAdminPage';
import { useAdminPermissions } from '../Hooks/useAdminPermissions';

const enablementModels = {
  'journey-maps': {
    key: 'journey-maps',
    label: 'Journey Maps',
    pageView: 'page.journeyMapsAdmin.view',
  },
  'education-scope': {
    key: 'education-scope',
    label: 'Education Scope',
    pageView: 'page.journeyMapsAdmin.view',
  },
  'due-dates': {
    key: 'due-dates',
    label: 'Due Dates',
    pageView: 'page.journeyMapsAdmin.view',
  },
  assignments: {
    key: 'assignments',
    label: 'Assignments',
    pageView: 'page.journeyMapsAdmin.view',
    adminOnly: true,
  },
};

// Assigning (and so auditing assignments) is an admin action; the same permissions gate the
// Assign Journeys page.
const ASSIGNMENT_ADMIN_PERMS = ['journey-map.assign', 'journey-map-admin.view'];


const AdminEnablement = () => {
  const { section } = useParams();
  const { hasAnyPerm } = useAdminPermissions();
  const canViewAssignments = hasAnyPerm(ASSIGNMENT_ADMIN_PERMS);
  const modelKeys = Object.keys(enablementModels).filter(
    (key) => !enablementModels[key].adminOnly || canViewAssignments
  );
  const [currentTabKey, setCurrentTabKey] = useState<string>(
    !!section && modelKeys.includes(section) ? section : modelKeys[0]
  );
  const navigate = useNavigate();

  const handleTabClick = (key: string) => {
    setCurrentTabKey(key);
    navigate(`${ADMIN_URL_ENABLEMENT}/${key}`);
  };

  return (
    <>
      <NavHistoryTracker title={currentTabKey} />
      <h1 className='mt-0 pb-6 border-b border-gray-15 text-gray-60 font-semibold leading-5'>
        Enablement
      </h1>
      <HbrTabGroup primary className='my-4'>
        {modelKeys.map((key) => (
          <HbrTab
            slot='nav'
            panel={key}
            key={key}
            onClick={() => handleTabClick(key)}
            active={key === currentTabKey}
          >
            {enablementModels[key].label}
          </HbrTab>
        ))}
        <HbrTabPanel name='journey-maps'>
          {currentTabKey === 'journey-maps' && <JourneyMapAdminPage />}
        </HbrTabPanel>
        <HbrTabPanel name='education-scope'>
          {currentTabKey === 'education-scope' && <EducationScopeAdminPage />}
        </HbrTabPanel>
        <HbrTabPanel name='due-dates'>
          {currentTabKey === 'due-dates' && <EnablementDueDatesAdminPage />}
        </HbrTabPanel>
        {canViewAssignments && (
          <HbrTabPanel name='assignments'>
            {currentTabKey === 'assignments' && <JourneyMapAssignmentsAdminPage />}
          </HbrTabPanel>
        )}
      </HbrTabGroup>
    </>
  );
};

export default AdminEnablement;
